import {
  InitializeWidgetRequest,
  InitializeWidgetResponse,
} from "@aichat/types/index";
import { axiosInstance } from "../lib/axios";
import { HeaderKeys } from "../lib/constants";

import axios from "axios";

const BASE_URL = "/widget";
export async function initializeWidget({
  apiKey,
  orgId,
}: InitializeWidgetRequest) {
  axios.defaults.headers.common[HeaderKeys.apiKey] = apiKey;
  axios.defaults.headers.common[HeaderKeys.organizationId] = orgId;
  const response = await axiosInstance.post<InitializeWidgetResponse>(
    BASE_URL,
    {
      domain:
        window.location != window.parent.location
          ? document.referrer
          : document.location.href,
    },
    {
      headers: {
        [HeaderKeys.apiKey]: apiKey,
        [HeaderKeys.organizationId]: orgId,
      },
    },
  );
  return response.data;
}
